import { startCase } from 'lodash';
import { InvoiceStatusEnum, IssueStatusEnum } from '../constants';

export const invoiceStatusList = ['P', 'PD', 'PP', 'C'];

export const getInvoiceStatus = (status: string) => {
  switch (status) {
    case InvoiceStatusEnum.PENDING:
      return 'Pending';
    case InvoiceStatusEnum.PARTIAL:
      return 'Partially Paid';
    case InvoiceStatusEnum.PAID:
      return 'Paid';
    case InvoiceStatusEnum.CANCELLED:
      return 'Cancelled';
    default:
      return startCase(status);
  }
};

export const getInvoiceStatusStyle = (status: string) => {
  switch (status) {
    case InvoiceStatusEnum.PENDING:
      return {
        backgroundClass: 'status-pending-bg',
        textClass: 'status-pending-text',
      };
    case InvoiceStatusEnum.PARTIAL:
      return {
        backgroundClass: 'status-pending-bg',
        textClass: 'status-pending-text',
      };
    case InvoiceStatusEnum.PAID:
      return {
        backgroundClass: 'status-approved-bg',
        textClass: 'status-approved-text',
      };
    case InvoiceStatusEnum.CANCELLED:
      return {
        backgroundClass: 'status-cancelled-bg',
        textClass: 'status-cancelled-text',
      };
    default:
      return {
        backgroundClass: 'status-pending-bg',
        textClass: 'status-pending-text',
      };
  }
};

export const getInvoiceIssueStatus = (status: string) => {
  switch (status) {
    case IssueStatusEnum.OPEN:
      return 'Open';
    case IssueStatusEnum.CLOSED:
      return 'Closed';
    default:
      return startCase(status);
  }
};

export const getInvoiceIssueStatusStyle = (status: string) => {
  switch (status) {
    case IssueStatusEnum.OPEN:
      return {
        backgroundClass: 'issue-open-bg',
        textClass: 'issue-open-text',
      };
    case IssueStatusEnum.CLOSED:
      return {
        backgroundClass: 'issue-closed-bg',
        textClass: 'issue-closed-text',
      };
    default:
      return {
        backgroundClass: 'issue-open-bg',
        textClass: 'issue-open-text',
      };
  }
};
